var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5795 8.00458L9.77283 13.0046C9.61616 13.2104 9.37366 13.3321 9.11533 13.3338H9.10949C8.85366 13.3338 8.61199 13.2154 8.45366 13.0138L6.42699 10.4246C6.14366 10.0629 6.20699 9.53875 6.56949 9.25542C6.93116 8.97125 7.45616 9.03458 7.73949 9.39792L9.10033 11.1363L12.2537 6.99542C12.532 6.62958 13.0545 6.55792 13.422 6.83708C13.7878 7.11625 13.8587 7.63875 13.5795 8.00458ZM10.0003 1.66708C5.39783 1.66708 1.66699 5.39792 1.66699 10.0004C1.66699 14.6021 5.39783 18.3337 10.0003 18.3337C14.6028 18.3337 18.3337 14.6021 18.3337 10.0004C18.3337 5.39792 14.6028 1.66708 10.0003 1.66708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSuccess);
export default __webpack_public_path__ + "static/media/notificationSuccess.37778f398941c9257e1980135f86aaa9.svg";
export { ForwardRef as ReactComponent };